<div
  class="popup_main_div corres_popup_main select_metter_main_div"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>Edit Account</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography">
    <!-- <div class="example-loading-shade" *ngIf="isLoadingResults">
            <mat-spinner [style.zoom]="1" *ngIf="isLoadingResults"></mat-spinner>
        </div> -->
    <div class="one select_matter_main_div">
      <div class="center list_tbl_main more_tbl_clmn shrink-0">
        <div class="matter-serach-div sticky_search_div">
          <form
            name="SelectContact"
            id="SelectContact"
            fxLayout="column"
            fxLayoutAlign="start"
            fxFlex="1 0 auto"
            name="form"
          >
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field appearance="outline" fxFlex="100" class="pr-1">
                <mat-label>Name</mat-label>
                <input readonly [(ngModel)]="accDialoge.Name" name="Name" matInput />
                <mat-icon matSuffix class="secondary-text"></mat-icon>
              </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-form-field appearance="outline" fxFlex="75" class="pr-1">
                <mat-label>Acc NO</mat-label>
                <input [(ngModel)]="accDialoge.AccNo" name="AccNo" matInput />
                <mat-icon matSuffix (click)="openAccount(accDialoge.AccType)">
                  <img src="assets/icons/web_app/icon_receipt_o.ico" />
                </mat-icon>
              </mat-form-field>
              <!-- <mat-icon fxFlex="25" matSuffix (click)='openAccount(accDialoge.AccType)'>
                                <img src="assets/icons/web_app/icon_receipt_o.ico"  >
                            </mat-icon> -->
            </div>
          </form>
        </div>
      </div>
      <!-- <div class="example-containerdata"> 

            </div> -->
    </div>
  </div>

  <mat-dialog-actions class="popup_ftr contact_select_footer justify-end!">
    <button mat-raised-button (click)="SaveClick()" color="accent">Save</button>
    <button matButton="tonal" [mat-dialog-close]="false" cdkFocusInitial>Don't Save</button>
  </mat-dialog-actions>
</div>
